export default "__VITE_PUBLIC_ASSET__63a8aeaf__"